module.exports = __webpack_public_path__ + "static/media/35wkndsf.910d674d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/35wkndsf.png
// module id = 128
// module chunks = 0